import { render, staticRenderFns } from "./WorkspacesIndex.vue?vue&type=template&id=3cca5756"
import script from "./WorkspacesIndex.vue?vue&type=script&lang=js"
export * from "./WorkspacesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports